export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "engineWater.worker.73d50d17f46394df6b61-870.worker.js");
}
